import { FacturaDetalle } from './FacturaDetalle';

export class Factura {
    
    idFormaPago:number;
    id:number;
    numeroFactura:string;
    totalSinImpuestos:number;
    establecimiento:string;
    totalDescuentos:number;
    totalConImpuestos:number;
    total:number;
    totalIva:number;
    tipoDoc:string;
    usuario:string;
    idCliente:number;
    idEmisor:number;
    valorTarjeta:number;
    valorEfectivo:number;
    llevar:string;
    det:  FacturaDetalle[]= [];
    observacion:string;
    enviado:string;
    caja:number 
     fechaHora:string;
    }
    